import { useState, createContext } from "react";
import type { FC, ReactNode } from "react";
import { WalletStandardProvider } from "@wallet-standard/react";
import type { Account, Balance } from "../type/types";

export const ConnectionStatusContext = createContext<{
  isConnected: boolean;
  accounts: Account[];
  balance: Balance;
  type: string;
  setAccounts: (accounts: Account[]) => void;
  setBalance: (balance: Balance) => void;
  setType: (type: any) => void;
  setLoading: (loading: boolean) => void;
  loading: boolean;
} | null>(null);

export const ConnectionStatusProvider: FC<{
  children: NonNullable<ReactNode>;
}> = ({ children }) => {
  const [accounts, setAccounts] = useState<Account[]>([]);
  const [balance, setBalance] = useState<Account[]>([]);
  const [type, setType] = useState<string>("");
  const [loading, setLoading] = useState<boolean>(false);

  const value = {
    isConnected: accounts.length > 0,
    accounts: accounts,
    setAccounts,
    balance: balance,
    setBalance: setBalance,
    setType: setType,
    type: type,
    setLoading: setLoading,
    loading: loading,
  };

  return (
    <WalletStandardProvider>
      <ConnectionStatusContext.Provider value={value}>
        {children}
      </ConnectionStatusContext.Provider>
    </WalletStandardProvider>
  );
};
